import { useTheme } from '@material-ui/core/styles'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import React from 'react'

interface PasswordVisibilityProps {
  showPassword: boolean
}

export const PasswordVisibility = (props: PasswordVisibilityProps) => {
  const { showPassword } = props
  const theme = useTheme()

  return (
    <>
      {showPassword ? (
        <>
          <VisibilityIcon
            style={{
              color: theme.palette.primary.main,
              fontSize: '22px',
            }}
          />
        </>
      ) : (
        <>
          <VisibilityOffIcon
            style={{
              color: theme.palette.primary.main,
              fontSize: '22px',
            }}
          />
        </>
      )}
    </>
  )
}
